module.exports = __webpack_public_path__ + "img/vsBronzer3.da778a9f.jpg";